import { Box, MenuItem, Select, FormControl } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontSize, fontWeight } from '../../../theme';

interface TableCellBodyStyledProps {
    $isOpenData: boolean
}

export const FilterTableBoxStyled = styled(Box)`
    &&{
        display: flex;
    }
`;

export const TableCellHeaderStyled = styled(TableCell)`
    && {
        border: none;
        background-color: #F8FAFC;
        font-weight: 500;
        font-family: barlow;
        color: #0F172A;
        line-height: 20px;
        font-size: 16px;
        vertical-align: bottom;
    }

`;

export const TableRowHeaderStyled = styled(TableRow)`
    && {
        display: table-row;
        vertical-align: text-top;
        outline: 0;
        height: 80px;
    }

`;

export const TextFieldDivStyled = styled.div`
    && {
        display: block;
        vertical-align: bottom;
    }

`;

export const TextFieldStyled = styled(TextField)`
    && {
        background-color: transparent;
        width: 100%;
        background-color: ${colors.grey800};
        border-radius: 8px;
        border-bottom: none;
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        font-weight: ${fontWeight.regular};
    }

`;

export const TableRowBodyStyled = styled(TableRow)`
    && {
        border: none;
        &:hover {
            background-color: ${colors.lighten};
            cursor: ${'pointer'};
            transition: background-color 500ms ease-in-out;
        }
    }

`;

export const TableCellBodyStyled = styled(TableCell)(({ $isOpenData } : TableCellBodyStyledProps) => `
    && {
        font-weight: 400;
        font-family: barlow;
        border: none;
        color: ${$isOpenData ? '#8C8C8C' : '#334155'};
        font-size: 1em;
        line-height: 5px;
        padding: 7px 7px 7px 30px;
    }
`);

export const TableContainerStyled = styled.div`
    && {
        width: 100%;
        height: 56vh;
        min-height: 400px;
        position: relative;
        display: flex;
        flex-direction: column;
        &&::-webkit-scrollbar {
            -webkit-appearance: none;
            height: 8px;
        }
    }
`;

export const StyledSelect = styled(Select)`
    && {
        max-width: 250px;
        ::before {
            display: none;
        }
    }
`;

export const HotAlertSelectFilterStyled = styled(StyledSelect)`
    && {
        background-color: ${colors.grey800};
        border-bottom: 1px solid;
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        font-weight: ${fontWeight.regular};
        margin: 0;
        .MuiSelect-select {
            &:focus {
                background-color: transparent;
            }

        }
        svg {
            padding-right: 0px;
            &.MuiSelect-iconOpen {
                padding-left: 0px;
            }
        }
    }
`;

export const HotAlertMenuItemStyled = styled(MenuItem)`
    && {
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        display: flex;
        justify-content: space-between;
        color: ${colors.grey100};

        &&.Mui-selected {
            opacity: 0.7;
        }
    }
`;

export const StyledHotAlertSelectFormControl = styled(FormControl)`
    && {
        min-width: 180px;
        margin-right: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0;
        width: 180px;
        @media print {
            display: none;
        }
    }
`;
